"use strict";
const gridBreakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400
};
const mqMinWidth = (mq) => window.matchMedia(`(min-width: ${gridBreakpoints[mq]}px)`);
const mqMaxWidth = (mq) => window.matchMedia(`(max-width: ${gridBreakpoints[mq] - 0.02}px)`);
exports.mqMaxWidth = mqMaxWidth;
exports.mqMinWidth = mqMinWidth;
